import { useState } from "react";

import {
  AddEditWinThemeDrawer,
  WinTheme,
} from "components/bid_module/win_themes/AddEditWinThemeDrawer";
import { WinThemeList } from "components/bid_module/win_themes/WinThemeList";
import Button from "components/ui/button/Button";
import { BidDetails } from "lib/hooks/api/bid/bids/useBid";
import { LoadingContent } from "../common_report_components/LoadingContent";
import ReportCollapse from "../common_report_components/ReportCollapse";

type Props = {
  bidId: string;
  bidName: string;
  winThemes: BidDetails["winThemes"];
  isStreaming: boolean;
};

export default function WinThemes({ bidId, bidName, winThemes, isStreaming }: Props) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [editingTheme, setEditingTheme] = useState<WinTheme | undefined>(undefined);
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);

  // Right-side action: spinner while streaming with no themes yet, otherwise the
  // "Add win theme" button.
  const headerAction = () => {
    if (isStreaming) {
      return !isCollapseOpen ? <LoadingContent /> : null;
    }
    return (
      <Button
        buttonType="secondary"
        icon="plus"
        onClick={() => {
          setEditingTheme(undefined);
          setIsDrawerOpen(true);
        }}
      >
        Win theme
      </Button>
    );
  };

  return (
    <>
      <ReportCollapse
        title="Win themes"
        open={isCollapseOpen}
        onOpenChange={setIsCollapseOpen}
        actions={headerAction()}
      >
        {winThemes.length === 0 && isStreaming ? (
          <LoadingContent />
        ) : (
          <WinThemeList
            bidId={bidId}
            bidName={bidName}
            winThemes={winThemes}
            onThemeClick={(theme) => {
              setEditingTheme(theme);
              setIsDrawerOpen(true);
            }}
          />
        )}
      </ReportCollapse>

      <AddEditWinThemeDrawer
        bidId={bidId}
        open={isDrawerOpen}
        onClose={() => {
          setIsDrawerOpen(false);
          setEditingTheme(undefined);
        }}
        theme={editingTheme}
      />
    </>
  );
}
